import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { SvgIconModule } from 'app/shared/svg-icon/svg-icon.module';
import { BannerModule } from 'app/shared/vendor-advertisement-banner/vendor-advertisement-banner.module';

@NgModule({
  declarations: [FooterComponent],
  imports: [CommonModule, SvgIconModule, BannerModule],
  exports: [FooterComponent],
})
export class FooterModule {}
